<template>
  <div
    class="form-input"
    :class="[{ 'form-input--full': !!value }, { 'form-input--error': error }]"
  >
    <input
      :value="value"
      type="text"
      :required="required"
      @input="$emit('input', $event.target.value)"
    />
    <slot />
    <span v-if="label" class="form-input__label"> {{ label }} </span>
    <span v-if="error" class="form-input--error-message">
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.form-input--error-message {
  font-size: 12px;
  color: #b73339;
}
</style>
